<template>
	<div class="introduce">
		<div class="">
			<div class="title">药销通——医药营销合规整体解决方案创领者</div>
			<div class="content flex-row">
				<div class="list flex-column">
					<div class="item flex-column" :class="index == activeIndex ? 'item-active' : ''" v-for="(item, index) in list" @click="change(index)">
						<div >{{ item.title }}</div>
						<div v-if="index == activeIndex" class="triangle"></div>
					</div>
				</div>
				<div class="right-content flex-column">
					<div class="subTitle">{{ list[activeIndex].subTitle }}</div>
					<div class="text">{{ list[activeIndex].text }}</div>
					<div class="button cursor"><el-button @click="toOpen">立即咨询</el-button></div>
					<div :class="activeIndex==1 ? 'img2':''" class="img flex-row flex-center"><img :src="list[activeIndex].imgUrl" alt=""></div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			activeIndex:0,
			list: [
				{
					title: '应对两票制解决方案',
					subTitle: '应对两票制解决方案',
					imgUrl:require('@/assets/home/introduce/introduce1.png'),
					text:
						'国内率先提出“基于业务、控于财务、安于税务”的两票制应对方案，代理商开办公司，解决进项票与药企营销费用科目匹配难题。'
				},
				{
					title: '回归服务业务真实性',
					subTitle: '回归服务业务真实性',
					text: '解决进项票对应的业务依据，回归推广服务的业务真实性，推出6大类48项医药推广服务项目及合规细则',
					imgUrl:require('@/assets/home/introduce/introduce2.png')
				},
				{
					title: '业财税一体化四级合规方案',
					subTitle: '业财税一体化四级合规方案',
					text: '率先提出“药企-代理商-自然人-医疗工作者”四级业务、财务和税务合规方案与思路，打通全链业财税一体化合规，应对税务穿透式稽查与审计。',
					imgUrl:require('@/assets/home/introduce/introduce3.png')
				},
				{
					title: '发挥数字化价值',
					subTitle: '发挥数字化价值',
					text: '充分利用互联网+与大数据，药企直接面向医生、店员、患者开展专业合规推广与服务，实现真实留痕与有效性。同年推出适合医疗设备与耗材的营销推广合规方案，建立4大类24项医疗器械推广服务项目。',
					imgUrl:require('@/assets/home/introduce/introduce4.png')
				},
				{
					title: '解决一线自然人问题',
					subTitle: '解决一线自然人问题',
					text: '规避混乱的“灵活用工”模式，开启自然人真实经营，税务直接代开，需求方与服务方直接服务外包与结算，解决营销费用最后一步难题。',
					imgUrl:require('@/assets/home/introduce/introduce5.png')
				},
				{
					title: '全业务管控合规',
					subTitle: '全业务管控合规',
					text: '解决企业内部与外部管控、线下与线上、自营与招商、医疗与非医疗市场的整合管控与合规一体化方案，回归医药全渠道推广过程的合规体系与能力建设。',
					imgUrl:require('@/assets/home/introduce/introduce6.png')
				},
				{
					title: '营销创新与变革的合规升级',
					subTitle: '营销创新与变革的合规升级',
					text: '拓展医生合作“阳光化”，临床项目合法化，拓展患者服务化，营销推广数字化，实现营销费用研发费用和管理费用化，解决CSO公司的专业化与自然人收入的经营化。',
					imgUrl:require('@/assets/home/introduce/introduce7.png')
				}
			]
		};
	},
	methods:{
		toOpen() {
			this.$router.push('/freeTrial');
		},
		change(index){
			this.activeIndex=index
		}
	}
	
};
</script>

<style lang="scss" scoped>
.content {
	width: $global-content-width;
	margin: 0 auto;
	justify-content: space-around;
	align-items: center;
}
.list {
	box-sizing: content-box;
	height: 611px;
	width: 350px;
	background: $global-default-primary;
	color: #ffffff;
	justify-content: space-between;
	> :not(:last-child) {
		border-bottom: 1px solid white;
	}
}
.right-content {
	// justify-content: space-between;
	position: relative;
	width: 849px;
	margin-left: 1px;
	height: 611px;
	background: #ffffff;
	box-shadow: 5px 5px 8px 0px rgba(212, 212, 212, 0.5), 5px -5px 8px 0px rgba(225, 225, 225, 0.5);
	.subTitle {
		margin-top: 102px;
		margin-left: 87px;
		width: 316px;
		height: 33px;
		font-size: 24px;
		font-weight: 600;
		color: #333333;
		line-height: 33px;
	}
	.text{
		margin-top: 34px;
		margin-left: 87px;
		width: 655px;
		height: 120px;
		font-size: 16px;
		font-weight: 400;
		color: #666666;
		line-height: 30px;
	}
	.button{
		text-align: center;
		line-height: 44px;
		margin-top: 164px;
		margin-left: 87px;
		width: 199px;
		height: 44px;
		background: #2970EC;
		border-radius: 4px;
		font-size: 18px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #FFFFFF;
	}
	.img{
		position: absolute;
		bottom: 32px;
		right: 0px;
		width: 515px;
		height: 321px;
		
		color: red;
		text-align: center;
		font-size: 28px;
		line-height: 321px;
		img{
			
		}

	}
	.img2{
		width: 611px;
		height: 383px;
		// background-color: red;
	}
}
.triangle {
	top: calc(50% - 14px);
	width: 13px;
	height: 14px;
	z-index: 9;
	position: absolute;
	right: -14px;
	border-top: 14px solid transparent;
	border-bottom: 14px solid transparent;
	border-left: 14px solid #2970ec;
	
}
.item {
	position: relative;
	transition: 0.5s;
	text-align: center;
	line-height: 85px;
	font-size: 18px;
	
}
.item-active {
	
	 background-image: linear-gradient(45deg, #53A9F7 , $global-default-primary);
	// background: $global-default-primary;
	color: #ffffff;
	font-size: 20px;
	height: 94px !important;
	font-size: 20px;
	line-height: 94px;
	font-weight: 600;
}

.title {
	margin: 0 auto;
	text-align: center;
	height: 45px;
	font-size: 32px;
	font-weight: 600;
	color: #333333;
	line-height: 45px;
	margin-bottom: 69px;
}
.introduce {
	margin-top: 105px;
	background-color: white;
}
</style>
